import { Box, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { Dispatch, SetStateAction } from 'react';
import { IConsultant } from 'wisestep-api';
import {
  Label,
  WsButton,
  WsColors,
  WsIconEdit,
  WsTypography,
  Item,
  WsTagsList,
  ChipsType,
} from 'wisestep-base';

interface renderBroadcastProps {
  tabId: number;
  consultantData: IConsultant;
  setUpdateState: Dispatch<SetStateAction<boolean>>;
}

export const StyledItem = styled(Item)({
  display: 'flex',
  alignItems: 'center',
});
export const StyledLabel = styled(Label)({
  fontWeight: 'bold',
  paddingRight: '5%',
  width: '50%',
});

const RenderBroadCastInfo = ({ tabId, consultantData, setUpdateState }: renderBroadcastProps) => (
  <Stack direction="column" width="80%" p={2}>
    <Box position="absolute" right="3%">
      <WsButton
        startIcon={<WsIconEdit color={WsColors.TheBlues500} />}
        variant="outlined"
        onClick={() => setUpdateState(true)}
      >
        Edit Details
      </WsButton>
    </Box>

    {tabId === 0 && (
      <Stack>
        <StyledItem>
          <StyledLabel>Name:</StyledLabel>
          <WsTypography>{consultantData.name}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Job Title:</StyledLabel>
          <WsTypography>{consultantData.jobTitle}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Email:</StyledLabel>
          <WsTypography>{consultantData.email}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Current Location:</StyledLabel>
          <WsTypography>
            {`${consultantData.location?.city},${consultantData.location?.country}` ??
              'Data not available'}
          </WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Visa Status:</StyledLabel>
          <WsTypography>{consultantData.visaStatus}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Visibility</StyledLabel>
          <WsTypography>{consultantData.visibility}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Resume</StyledLabel>
          <WsButton variant="outlined" size="small">
            View Resume
          </WsButton>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Other Documents</StyledLabel>
          <WsButton variant="outlined" size="small">
            View Docs
          </WsButton>
        </StyledItem>
      </Stack>
    )}
    {tabId === 1 && (
      <Stack>
        <StyledItem>
          <StyledLabel>Preferred Locations:</StyledLabel>
          <WsTagsList
            chipArray={
              consultantData.preferredLocations?.map(
                (location) => `${location.city},${location.country}`
              ) ?? ['No Data Available']
            }
            count={3}
            type={ChipsType.PRIMARY}
          />
        </StyledItem>
        <StyledItem>
          <StyledLabel>Phone Number:</StyledLabel>
          <WsTypography>{consultantData?.phoneNumber ?? 'Not Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Skills:</StyledLabel>
          <WsTagsList
            chipArray={
              consultantData.skills?.map((skill) => skill.skill ?? 'No Data') ?? [
                'No Data Available',
              ]
            }
            count={3}
            type={ChipsType.PRIMARY}
          />
        </StyledItem>
        <StyledItem>
          <StyledLabel>Experience:</StyledLabel>
          <WsTypography>{consultantData.totalYearsExperience ?? 'No Data Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Education</StyledLabel>
          <WsTypography>{consultantData.education ?? 'No Data Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Pay/Hour</StyledLabel>
          <WsTypography>
            {`${consultantData.salaryPerHour}${consultantData.salaryCurrency}` ??
              'No Data Available'}
          </WsTypography>
        </StyledItem>
      </Stack>
    )}
    {tabId === 2 && (
      <Stack>
        <StyledItem>
          <StyledLabel>Owner Name:</StyledLabel>
          <WsTypography>{consultantData.ownerName ?? 'No Data Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Owner Email:</StyledLabel>
          <WsTypography>{consultantData.ownerId ?? 'No Data Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Owner Phone:</StyledLabel>
          <WsTypography>{consultantData.ownerPhone ?? 'No Data Available'}</WsTypography>
        </StyledItem>
        <StyledItem>
          <StyledLabel>Owner Company:</StyledLabel>
          <WsTypography>{consultantData.ownerCompany ?? 'No Data Available'}</WsTypography>
        </StyledItem>
      </Stack>
    )}
  </Stack>
);

export default RenderBroadCastInfo;
